(function () {
  const HIDDEN_PICKER_STYLE = 'w1gk-pdp-size--hide-fabric-picker';

  const getSizeRoot = () => document.querySelector('[data-w1gk-pdp-size]');

  const getVariantPicker = () =>
    document.querySelector('variant-picker[data-template-product-match="true"]');

  const getConfig = () => {
    const el = document.getElementById('w1gk-pdp-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  };

  const findProductForm = () =>
    document.querySelector('[data-w1gk-pdp-form]') ||
    document.querySelector('.w1gk-pdp-atc form[data-type="add-to-cart-form"]') ||
    document.querySelector('.product-information product-form-component form[data-type="add-to-cart-form"]');

  const findVariantBySize = (config, size) => {
    if (!config || !size) return null;
    return config.variants.find((v) => v.size === size) ?? null;
  };

  const syncVariantInput = (sizeValue) => {
    const config = getConfig();
    const variant = findVariantBySize(config, sizeValue);
    if (!variant) return false;

    const form = findProductForm();
    const input = form?.querySelector('[name="id"]');
    if (!input) return false;

    input.value = String(variant.id);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variant.id));
    window.history.replaceState({}, '', url);

    let sizeProperty = form.querySelector('[name="properties[Rozmiar]"]');
    if (!sizeProperty) {
      sizeProperty = document.createElement('input');
      sizeProperty.type = 'hidden';
      sizeProperty.name = 'properties[Rozmiar]';
      form.appendChild(sizeProperty);
    }
    sizeProperty.value = sizeValue;

    return true;
  };

  const selectFabricSize = (sizeValue) => {
    const picker = getVariantPicker();
    if (!picker) return false;

    const input = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
      (el) => el.value === sizeValue && el.dataset.optionAvailable !== 'false'
    );

    if (!input) return false;

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  };

  const syncActiveSize = (sizeValue) => {
    if (!sizeValue) return;
    document.querySelectorAll('[data-w1gk-size]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.w1gkSize === sizeValue);
    });
    document.querySelectorAll('[data-w1gk-size-label]').forEach((el) => {
      el.textContent = sizeValue;
    });
  };

  const readSizeFromVariant = (variant, position) => {
    if (!variant) return '';
    const key = `option${position}`;
    return variant[key] || '';
  };

  const bindSizeButtons = (root) => {
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-w1gk-size]');
      if (!btn || btn.disabled) return;
      const size = btn.dataset.w1gkSize;
      if (!selectFabricSize(size)) {
        syncActiveSize(size);
        syncVariantInput(size);
      }
    });
  };

  const bindFormGuard = () => {
    const form = findProductForm();
    if (!form || form.dataset.w1gkSizeGuard === 'true') return;
    form.dataset.w1gkSizeGuard = 'true';

    form.addEventListener(
      'submit',
      () => {
        const active = document.querySelector('[data-w1gk-size].is-active');
        const size = active?.dataset.w1gkSize || getSizeRoot()?.dataset.w1gkDefaultSize;
        if (size) syncVariantInput(size);
      },
      true
    );
  };

  const bindModal = () => {
    /* Modal: assets/w1gk-glove-finder.js (footer overlay section) */
  };

  const bindVariantSync = (root) => {
    const position = Number(root.dataset.w1gkOptionPosition || '1');

    document.addEventListener('variant:update', (e) => {
      const variant = e.detail?.resource;
      const size = readSizeFromVariant(variant, position);
      if (size) syncActiveSize(size);
    });
  };

  const boot = () => {
    const root = getSizeRoot();
    if (!root) return;

    document.documentElement.classList.add(HIDDEN_PICKER_STYLE);
    bindSizeButtons(root);
    bindModal();
    bindVariantSync(root);
    bindFormGuard();

    const initial = root.dataset.w1gkDefaultSize;
    if (initial) {
      syncActiveSize(initial);
      if (!getVariantPicker()) syncVariantInput(initial);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
